<template>
  <div class="bq-page" :class="{ 'bq-page-wireless': isMobile }">
    <banner
      :cover="banner.cover"
      :mcover="banner.mcover"
      :title="banner.title"
    />

    <div class="bq-page-content">
      <box
        class="bq-box-information"
        v-for="(item, index) in aboutData.informations"
        :key="index"
      >
        <overlap-card
          class="bq-box-item"
          :flip="index % 2 !== 0"
          :title="item.title"
          :cover="item.img"
          :mcover="item.mimg"
        >
          <ul class="bq-box-item-content" slot="content">
            <li v-for="cell in item.content" :key="cell">{{ cell }}</li>
          </ul>
        </overlap-card>
      </box>

      <!-- 加入我们 -->
      <box class="bq-box-jobs" title="加入我们">
        <div class="bq-box-wrap">
          <ul class="bq-jobs-list">
            <li
              class="bq-jobs-item"
              v-for="(item, index) in aboutData.jobs"
              :key="index"
              @click="showJobDetail(index)"
            >
              <figure
                class="bq-jobs-img"
                :style="{ 'background-color': `#${item.color}` }"
              >
                <img :src="item.icon" alt="item.name" />
              </figure>
              <h4>{{ item.name }}</h4>
            </li>
          </ul>
        </div>
      </box>

      <box class="bq-box-contact" title="联系我们">
        <card
          class="bq-box-map"
          :layout="!isMobile ? 'horizontal' : 'vertical'"
          size="map"
          :cover="aboutData.map"
        >
          <div class="bq-box-map-detail" slot="content">
            <p v-if="!isMobile">联系电话：{{ aboutData.info.tel }}</p>
            <p v-else>
              联系电话：
              <a :href="`tel:+${aboutData.info.tel}`">
                {{ aboutData.info.tel }}
              </a>
            </p>

            <p>公司地址：{{ aboutData.info.address }}</p>
          </div>
        </card>
      </box>
    </div>

    <!-- job 的弹窗详情 -->
    <bq-dialog class="bq-dialog" :visible="visible" :onHide="hideJobDetail">
      <article
        class="bq-article-job"
        v-for="item in activeJob.description"
        :key="item.title"
      >
        <h4>{{ item.title }}</h4>
        <div class="bq-article-content">
          <p v-for="cell in item.content" :key="cell">{{ cell }}</p>
        </div>
      </article>

      <a
        class="bq-job-mail"
        :href="`mailto:${aboutData.info.email}`"
        target="_blank"
        slot="footer"
      >
        {{ aboutData.info.email }}
      </a>
    </bq-dialog>
  </div>
</template>

<script>
import Banner from '@/components/Banner';
import Box from '@/components/Box';
import OverlapCard from '@/components/OverlapCard';
import Card from '@/components/Card';
import BqDialog from '@/components/Dialog';

import { banner, aboutData } from './about.js';
import { locatTo, isWirelessDevice } from '../../../utils/utils.js';

export default {
  name: 'about',

  components: {
    Banner,
    Box,
    OverlapCard,
    Card,
    BqDialog,
  },

  data() {
    return {
      isMobile: false,
      banner,
      aboutData,
      visible: false,
      activeJob: {},
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  mounted() {
    this.$route.query.locat && this.locatTo(this.$route.query.locat);
  },

  methods: {
    showJobDetail(index) {
      if (this.isMobile) {
        // this.$router.push(`/job?id=${index}`);
        location.href = `/job?id=${index}`;

        return;
      }

      this.activeJob = this.aboutData.jobs[index];
      this.visible = true;
    },

    hideJobDetail() {
      this.activeJob = {};
      this.visible = false;
    },

    // 应用于底部导航的页面跳转定位
    locatTo(locatName) {
      const posYArr = {
        intro: 150,
        culture: 150,
        jobs: 50,
        concat: 100,
      };

      setTimeout(() => {
        const target = document.getElementsByClassName(locatName);
        if (target.length) {
          locatTo(target[0].offsetTop - posYArr[locatName]);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
